import { render, staticRenderFns } from "./Editer_livreur.vue?vue&type=template&id=6e16a5b0&"
import script from "./Editer_livreur.vue?vue&type=script&lang=js&"
export * from "./Editer_livreur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports